import Vue from "vue";
import Router from "vue-router";
import routes from "./router";
import store from "../store/index";

Vue.use(Router);
// console.log(store);
const router = new Router({
  // mode:'history',
  mode: "hash",
  // base:process.env.BASE_URL,
  routes,
});

// let count = 1
let whiteList = ["/404", "/home", "/login"];

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

router.beforeEach((to, from, next) => {
  // console.log("from", `'${from.fullPath}'`, "to", `'${to.path}'`);
  store.commit('SET_PATH', to.path)
  if (!whiteList.includes(to.path)) {
    let token = store.state.token;
    // if (!token) {
    //   next({ path: "/home", query: { ReturnUrl: to.fullPath } });
    // } else {
      next();
    // }
  } else {
    next();
  }

});

router.afterEach((to, from) => {
  localStorage.setItem("savedRoute", to.fullPath);
});

export default router;
